import React from 'react';

export default function SectionLabel({ children, className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="inline-block w-[3px] h-4 bg-[#e11f3a]" />
      <h4 className="text-[13px] tracking-[0.25em] font-semibold text-black">{children}</h4>
    </div>
  );
}
